var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCsp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 156,
    viewBox: "0 0 156 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.8632 53.0122H38.2826L35.4756 58.3517H39.2464L39.0922 73.6763H65.9439L65.8632 53.0122Z",
    fill: "white",
    stroke: "#0E171E",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7646 53.0845V73.5607",
    stroke: "#0E171E",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2334 59.6618H44.6683L46.6931 53.0845L44.1798 58.2973L39.2457 58.2805L39.2334 59.6618Z",
    fill: "#0E171E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7881 55.8843L48.907 58.4866H53.6168V55.8843H48.7881Z",
    stroke: "#0E171E",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9619 59.8599H53.7038",
    stroke: "#0E171E",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1229 99.5015H27.4297V123.177H91.1229V99.5015Z",
    fill: "white",
    stroke: "#0E171E",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4199 99.5015V123.177",
    stroke: "#0E171E",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8994 99.4888V123.177",
    stroke: "#0E171E",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4297 111.168L48.325 111.496L44.3927 113.105L48.5853 114.426L27.4297 114.146V111.168Z",
    fill: "#0E171E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2969 99.3291L63.5456 123.007L67.9984 99.3315L62.2969 99.3291Z",
    fill: "#0E171E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8623 102.827H81.041L85.3782 104.374L81.6916 105.863L88.9732 105.763L88.8623 102.827Z",
    fill: "#0E171E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5162 101.655H41.79V105.862H52.5162V101.655Z",
    stroke: "#0E171E",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2628 104.858C50.8696 104.858 51.3615 104.366 51.3615 103.759C51.3615 103.152 50.8696 102.66 50.2628 102.66C49.656 102.66 49.1641 103.152 49.1641 103.759C49.1641 104.366 49.656 104.858 50.2628 104.858Z",
    stroke: "#0E171E",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2744 104.576H45.0671",
    stroke: "#0E171E",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2744 103.217H47.9296",
    stroke: "#0E171E",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M39.332 78.3506L39.4188 99.5015H70.0953L69.7787 78.3506H39.332Z",
    fill: "white",
    stroke: "#0E171E",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7278 73.6763L31.6699 78.3507H73.1618L73.2197 73.6763H31.7278Z",
    fill: "#0E171E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7744 73.9268V78.2061",
    stroke: "white",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7139 78.3506L55.0039 99.2556",
    stroke: "#0E171E",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3416 80.6784L55.0035 78.3506H39.332L39.3416 80.6784Z",
    fill: "#0E171E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2441 78.3506H54.7142",
    stroke: "white",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0417 92.6904H52.8458C52.9696 92.6904 53.0701 92.7909 53.0701 92.9147V94.2668C53.0701 95.1644 52.3413 95.8932 51.4437 95.8932C50.5461 95.8932 49.8174 95.1644 49.8174 94.2668V92.9147C49.8174 92.7909 49.9179 92.6904 50.0417 92.6904Z",
    fill: "#0E171E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4434 95.7578L51.4434 97.355",
    stroke: "#0E171E",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2461 97.3965L52.6069 97.3965",
    stroke: "#0E171E",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7334 94.2427L46.7334 97.3966",
    stroke: "#0E171E",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7164 92.4409L45.124 95.199L48.3088 95.199L46.7164 92.4409Z",
    fill: "#0E171E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M43.042 94.2427L43.042 97.3966",
    stroke: "#0E171E",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8447 97.3965L47.8965 97.3965",
    stroke: "#0E171E",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M43.025 92.4409L41.4326 95.199H44.6174L43.025 92.4409Z",
    fill: "#0E171E"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4639 81.0396V99.4987L89.963 99.5014L90.2794 81.0396H62.4639Z",
    fill: "white",
    stroke: "#0E171E",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1465 81.0547L73.9424 99.5015",
    stroke: "#0E171E",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2166 82.543H78.4531V85.6512H86.2166V82.543Z",
    stroke: "#0E171E",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7565 84.8635C85.1796 84.8635 85.5227 84.5205 85.5227 84.0973C85.5227 83.6741 85.1796 83.3311 84.7565 83.3311C84.3333 83.3311 83.9902 83.6741 83.9902 84.0973C83.9902 84.5205 84.3333 84.8635 84.7565 84.8635Z",
    stroke: "#0E171E",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7979 83.4248H82.7471",
    stroke: "#0E171E",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8848 84.3936H81.4606",
    stroke: "#0E171E",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4639 83.1214L74.232 81.0396H62.4639V83.1214Z",
    fill: "#0E171E"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5447 121.413C87.526 121.414 87.3437 121.425 87.2301 121.549C87.0948 121.698 87.0959 121.966 87.2862 122.159C87.1155 121.958 86.8456 121.925 86.6733 122.038C86.5222 122.138 86.489 122.323 86.4865 122.338C86.4483 122.569 86.6377 122.717 86.7012 122.767C86.9102 122.93 87.1823 122.934 87.534 122.94C87.6964 122.943 87.8314 122.934 87.9193 122.925C87.9963 122.687 88.0244 122.49 88.0355 122.353C88.0573 122.081 88.0784 121.819 87.9158 121.613C87.8685 121.553 87.7519 121.405 87.5447 121.413Z",
    fill: "#0E171E"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8366 117.073C89.8222 118.76 89.8317 120.628 89.8173 122.315C89.146 122.617 88.1363 123.153 87.3228 123.982C86.8835 124.429 86.6422 124.807 86.6656 125.221C86.6656 125.221 86.6784 125.446 86.7802 125.64C87.264 126.565 91.8805 126.223 96.8001 124.252C97.8759 123.821 98.7118 123.414 99.171 123.182C99.366 121.212 99.6073 119.017 99.8023 117.048C96.5039 117.042 93.1351 117.079 89.8366 117.073Z",
    fill: "white",
    stroke: "#0E171E",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8477 117.105V118.29L100.488 116.984L89.8477 117.105Z",
    fill: "#0E171E"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M99.802 117.048C99.7105 118.015 99.6189 118.982 99.5273 119.949C100.121 120.181 101.061 120.543 102.226 120.961C108.846 123.336 109.853 122.915 110.187 122.493C110.224 122.446 110.346 122.293 110.372 122.068C110.482 121.117 108.671 120.692 108.231 119.467C108.05 118.965 108.185 117.958 108.987 116.72C106.394 114.905 103.533 113.163 100.94 111.348C100.812 113.171 100.813 115.143 100.685 116.966C100.391 116.993 100.096 117.02 99.802 117.048Z",
    fill: "white",
    stroke: "#0E171E",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M110.779 119.91C110.779 119.891 110.777 119.709 110.658 119.59C110.516 119.447 110.248 119.436 110.046 119.617C110.255 119.456 110.301 119.188 110.195 119.01C110.102 118.855 109.919 118.813 109.904 118.81C109.675 118.761 109.519 118.943 109.466 119.005C109.293 119.206 109.276 119.477 109.254 119.828C109.244 119.99 109.247 120.126 109.251 120.214C109.485 120.302 109.681 120.339 109.817 120.357C110.088 120.391 110.349 120.424 110.562 120.271C110.625 120.227 110.778 120.117 110.779 119.91Z",
    fill: "#0E171E"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M108.472 117.637L101.069 111.496L108.987 116.72L108.472 117.637Z",
    fill: "#0E171E"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5039 119.944L99.8011 117.048L100.775 117.048L100.855 114.276L101.873 120.834L99.5039 119.944Z",
    fill: "#0E171E"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M117.922 90.6025L118.596 92.0209L119.581 94.4888L119.909 96.0656V97.8471L119.12 99.9785L116.687 104.014L110.778 113.759L108.986 116.72L100.941 111.297L101.082 108.081L106.423 100.205L108.548 97.2783L107.863 96.6817L101.618 87.8272L100.939 108.661L100.661 116.959L89.3632 117.041L88.5781 94.2735L92.8346 92.915L92.5391 69.2183L94.2401 69.4465H96.9002L98.5594 69.3691L100.153 71.6075L117.922 90.6025Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M117.889 90.5332L119.357 93.9071C120.264 95.9921 120.102 98.3877 118.923 100.332L108.986 116.72L100.939 111.348L101.023 108.175L107.539 98.5657C108.266 97.4936 109.192 96.5708 110.266 95.8473L112.977 94.0223",
    stroke: "#0E171E",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M110.29 114.554L101.16 108.181",
    stroke: "#0E171E",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M101.595 87.6733L107.785 96.5824C108.171 97.1394 108.799 97.4809 109.476 97.5038L111.126 97.5596",
    stroke: "#0E171E",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M101.873 78.9966L100.775 117.048H89.3632L88.5781 94.3461",
    stroke: "#0E171E",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2832 114.734L100.621 115.043",
    stroke: "#0E171E",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2903 63.9104C96.1241 63.7873 94.338 62.5701 93.5669 62.2681C92.7957 61.9661 92.3676 62.6623 92.3676 62.6623L92.3562 62.1755L92.0771 45.7151L93.5371 44.085C93.6905 44.308 94.3253 45.1737 95.379 45.3616C96.257 45.5182 97.1917 45.1885 97.8997 44.5004L98.2903 63.9104Z",
    fill: "#0E171E"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6523 38.9351C97.3723 38.3988 99.0529 38.0157 100.209 38.1287C100.214 38.1292 100.232 38.1299 100.254 38.1312C102.031 38.2376 104.27 39.4405 104.939 41.254C105.258 42.1209 105.149 42.8403 105.054 43.6539C104.858 45.3426 104.685 47.7684 104.823 50.9113C106.428 52.6707 108.6 55.5937 109.661 59.682C109.947 60.7819 110.114 61.8219 110.205 62.776C116.131 71.4662 122.057 80.1565 127.983 88.8468C124.244 89.5215 120.504 90.1961 116.764 90.8708C115.063 86.298 111.679 79.4837 104.881 74.1005C103.477 72.989 102.074 72.0547 100.717 71.2669C100.004 70.679 98.4417 69.4655 98.4417 69.4655L97.8212 45.3695C97.8212 45.3695 97.7632 42.8892 98.6286 41.7726C97.8369 40.5018 97.444 40.2059 96.6523 38.9351Z",
    fill: "#6AD67D"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7347 43.6826L90.2432 44.2268C88.0103 45.0415 86.2243 46.7599 85.3239 48.9597L82.8291 55.0555L86.8385 63.3828L87.918 69.3874L87.2819 94.6873L92.7756 92.9139L92.1202 43.6826H91.7347Z",
    fill: "#6AD67D"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4414 69.4653L116.764 90.8706C116.764 90.8706 115.846 82.3669 115.294 79.0391C115.189 78.4009 114.985 77.7921 114.697 77.2307C114 75.8726 112.788 74.8497 111.358 74.3133L98.4414 69.4653Z",
    fill: "white",
    stroke: "#0E171E",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8356 94.1073L92.8181 92.894L88.5791 94.2735L92.8356 94.1073Z",
    fill: "#0E171E"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9697 60.3705C100.297 60.3705 100.562 60.1052 100.562 59.7778C100.562 59.4504 100.297 59.1851 99.9697 59.1851C99.6423 59.1851 99.377 59.4504 99.377 59.7778C99.377 60.1052 99.6423 60.3705 99.9697 60.3705Z",
    fill: "#0E171E"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8154 54.9443C100.143 54.9443 100.408 54.6789 100.408 54.3515C100.408 54.0242 100.143 53.7588 99.8154 53.7588C99.488 53.7588 99.2227 54.0242 99.2227 54.3515C99.2227 54.6789 99.488 54.9443 99.8154 54.9443Z",
    fill: "#0E171E"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M99.665 49.6259C99.9924 49.6259 100.258 49.3605 100.258 49.0332C100.258 48.7058 99.9924 48.4404 99.665 48.4404C99.3376 48.4404 99.0723 48.7058 99.0723 49.0332C99.0723 49.3605 99.3376 49.6259 99.665 49.6259Z",
    fill: "#0E171E"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5459 45.4159C99.8732 45.4159 100.139 45.1506 100.139 44.8232C100.139 44.4958 99.8732 44.2305 99.5459 44.2305C99.2185 44.2305 98.9531 44.4958 98.9531 44.8232C98.9531 45.1506 99.2185 45.4159 99.5459 45.4159Z",
    fill: "#0E171E"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9139 43.8563C90.9085 44.0571 90.8414 44.4672 91.1899 44.9941C91.495 45.4554 91.9066 45.6134 92.1534 45.5709C92.6493 44.9357 93.1626 44.4251 93.6585 43.7899C93.3826 43.2985 93.2496 42.8989 92.9919 42.3008C92.8693 42.0162 92.7585 41.7381 92.6582 41.4678C92.5489 41.5259 90.9532 42.4035 90.9139 43.8563Z",
    fill: "#6AD67D",
    stroke: "#0E171E",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6187 40.1661C97.651 40.093 97.8724 39.997 97.9363 39.9602C98.0638 39.8866 98.1933 39.8165 98.3254 39.7514C98.5828 39.6244 98.8502 39.5163 99.1272 39.4401C99.6702 39.2909 100.26 39.2689 100.79 39.4588C100.839 39.4763 100.898 39.5222 100.872 39.5673C100.864 39.5806 100.85 39.5891 100.837 39.597C100.707 39.6752 100.576 39.7533 100.445 39.8314C100.278 39.9316 100.11 40.0321 99.9529 40.1487C99.5093 40.4786 99.1667 40.9303 98.9072 41.4184C98.8503 41.5254 98.7968 41.635 98.7258 41.7331C98.7148 41.7483 98.7024 41.7639 98.6847 41.7699C98.642 41.7844 98.6291 41.7725 98.6291 41.7725C98.6291 41.7725 97.6036 40.238 97.6045 40.1935C97.6046 40.1883 97.6163 40.1717 97.6187 40.1661Z",
    fill: "#0E171E"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5791 94.2735L92.8181 92.894",
    stroke: "white",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M100.489 42.4947C104.021 41.7324 107.659 43.1954 109.628 46.2247L118.472 59.8277C119.89 62.0058 118.846 64.9347 116.372 65.7271L103.684 69.791C102.859 70.0546 101.978 69.5861 101.736 68.7521L101.71 68.6618L99.9945 69.3869L98.6934 63.4745L100.422 63.5462C100.414 63.4702 100.41 63.3943 100.41 63.3198C100.41 62.3841 100.972 61.5272 101.85 61.1618L108.251 58.5738L102.492 50.6161",
    fill: "#6AD67D"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M100.489 42.4947C104.021 41.7324 107.659 43.1954 109.628 46.2247L118.472 59.8277C119.89 62.0058 118.846 64.9347 116.372 65.7271L103.684 69.791C102.859 70.0546 101.978 69.5861 101.736 68.7521L101.71 68.6618L99.9945 69.3869L98.6934 63.4745L100.422 63.5462C100.414 63.4702 100.41 63.3943 100.41 63.3198C100.41 62.3841 100.972 61.5272 101.85 61.1618L108.251 58.5738L102.492 50.6161",
    stroke: "#0E171E",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M100.422 63.5464L101.71 68.662",
    stroke: "#0E171E",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9926 53.5557L73.401 56.2191C72.6725 56.4214 72.3682 57.2873 72.81 57.9008L81.5147 69.9898C82.3036 71.0853 83.6953 71.5676 84.9929 71.1952L96.4623 67.9034L86.5118 54.7462C85.694 53.665 84.2988 53.193 82.9926 53.5557Z",
    fill: "white",
    stroke: "#0E171E",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2842 54.0299L82.5853 51.2287C82.7073 50.9699 83.0221 50.8672 83.2733 51.0042C83.5254 51.1417 83.609 51.4634 83.4558 51.7062L82.5504 53.6783L81.2842 54.0299Z",
    fill: "#0E171E"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6001 63.8026C97.668 63.7723 97.0124 63.6095 96.3802 63.4025C94.5796 62.8127 93.5011 61.7796 92.776 62.126C92.6649 62.1785 92.4297 62.3815 92.4933 62.5532C92.6437 62.9581 93.0537 63.3843 93.1103 63.4176C92.6831 63.7701 92.0308 64.2094 91.0451 64.5446C89.2557 65.1525 87.5056 64.8617 87.4551 65.1909C87.4349 65.3273 87.7187 65.4747 87.8389 65.5363C88.3256 65.7847 88.9113 65.8938 89.5092 65.92C89.2012 65.919 88.8922 65.9311 88.5831 65.9271C88.06 65.921 87.7298 65.9009 87.6551 66.0624C87.6248 66.1281 87.648 66.1977 87.6632 66.2381C87.8338 66.6986 88.7285 66.8622 88.9245 66.8935C88.6346 66.8632 88.4448 66.8642 88.4074 66.9582C88.3337 67.144 88.9033 67.553 89.282 67.7539C89.7081 67.9791 90.106 68.0549 90.3645 68.0821C89.6546 68.0528 89.2244 67.9933 89.2002 68.0862C89.1608 68.2397 90.2645 68.6507 90.5776 68.7607C91.8187 69.197 94.3205 69.7335 99.7828 69.2901L98.6001 63.8026ZM89.5183 65.92C89.8172 65.9221 90.2514 65.914 90.7887 65.8695L90.7897 65.8706C90.3817 65.915 89.9474 65.9392 89.5183 65.92Z",
    fill: "white",
    stroke: "#0E171E",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8389 65.5365C89.3529 66.3093 91.8281 65.7297 92.6071 65.5273",
    stroke: "#0E171E",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M89.915 68.0592C90.2235 68.0772 90.6216 68.099 91.0892 68.096C91.8322 68.0912 92.4392 68.0258 92.8385 67.9707",
    stroke: "#0E171E",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M88.877 66.8892C89.2044 66.9211 89.6738 67.0017 90.1997 67.031C90.9183 67.0709 91.9223 67.0251 93.1562 66.6406",
    stroke: "#0E171E",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9036 69.2998C98.9036 69.2998 98.7874 66.0782 98.6396 63.9321C99.1826 66.1136 99.8578 69.2481 99.8578 69.2481L98.9036 69.2998Z",
    fill: "#0E171E"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5795 43.8942C95.4744 46.7409 97.9206 44.3731 97.9206 44.3731C97.8481 43.2568 98.6413 41.7724 98.6413 41.7724C98.6413 41.7724 96.9864 39.22 95.9301 37.6226C96.2513 37.2847 96.5045 37.1384 96.5806 36.9311C96.8516 36.1938 96.7215 35.3925 96.4644 34.9471C96.3496 34.7482 96.2175 34.6105 96.1325 34.5312C96.0168 34.4156 95.9012 34.2999 95.7855 34.1842C95.3231 33.9973 94.7443 33.8172 94.0651 33.7216C92.4236 33.4905 90.8607 33.9762 90.1147 34.2595C90.1147 34.7719 89.9034 38.1363 89.7839 39.9988C89.7397 40.6871 90.2519 41.2844 90.9387 41.3469L92.2731 41.4683L93.5795 43.8942Z",
    fill: "white",
    stroke: "#0E171E",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M95.624 36.1064C95.5621 36.3279 95.4819 36.7088 95.0596 37.2154",
    stroke: "#0E171E",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8059 38.3145C93.7344 38.4538 93.6074 38.657 93.3915 38.8445C93.0442 39.1461 92.6692 39.2311 92.4951 39.259",
    stroke: "#0E171E",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7251 36.9746C91.7274 37.3415 91.6639 37.6239 91.5999 37.8228C91.5146 38.0874 91.3915 38.3182 91.4938 38.4492C91.5451 38.5149 91.6348 38.5322 91.7059 38.536",
    stroke: "#0E171E",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M93.493 36.7407C93.4928 36.7805 93.4871 36.8635 93.4377 36.952C93.3938 37.0306 93.3359 37.0766 93.3037 37.0987",
    stroke: "#0E171E",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1203 36.4199C91.1132 36.4757 91.0966 36.5541 91.0554 36.6397C91.026 36.7008 90.9922 36.7488 90.9629 36.7843",
    stroke: "#0E171E",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8791 34.2371C89.8149 35.2235 91.2164 36.2077 92.4189 36.3384C93.651 36.4723 94.8045 35.7246 94.8669 35.683C95.4982 35.2632 95.7157 34.8368 95.9946 34.9312C96.3702 35.0585 96.4575 35.9954 96.2934 36.6854C96.1953 37.0977 96.0114 37.4054 95.8769 37.5948C96.2374 38.1543 96.5979 38.7137 96.9584 39.2732C97.4015 37.05 97.0191 35.3945 96.7441 34.5377C96.4225 33.5356 96.1182 32.5876 95.2236 32.1169C94.0246 31.4862 92.6004 32.152 91.8406 32.5073C91.0494 32.8771 89.9336 33.3987 89.8791 34.2371Z",
    fill: "#0E171E"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M100.019 31.0809C99.8945 30.9085 99.3066 30.1452 98.3659 30.146C97.3732 30.1469 96.4505 30.9983 96.3467 32.0351C96.2712 32.7894 96.6378 33.5552 97.2623 33.953C98.3027 34.6158 99.8847 34.1466 100.347 33.0952C100.764 32.1449 100.074 31.1569 100.019 31.0809Z",
    fill: "#0E171E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsp);
export default __webpack_public_path__ + "static/media/csp.dabae750dd22948f38568513c3207d44.svg";
export { ForwardRef as ReactComponent };